module.exports = __webpack_public_path__ + "img/desktop.3aa0a4ca.png";